import PageTemplateService from '@/component/templates/PageTemplate/_service/PageTemplateService'
import { clsx } from 'clsx'
import useRepository from '@/hooks/useRepository'
import { Icon } from '@design-system/components/atoms'
import { mediaQuery, typo } from '@design-system/styles'
import { css } from '@emotion/react'
import React from 'react'
import { observer } from 'mobx-react'

const SideNavigationOpenButton = () => {
  const service = useRepository(PageTemplateService)

  return (
    <button
      css={_Style}
      onClick={() => service.setSideNavigationOpen(!service.isSideNavigationOpen)}
    >
      <div className="left">
        <div className="dot" />
        메뉴 {service.isSideNavigationOpen ? '닫기' : '열기'}
      </div>
      <div className={clsx('icon-wrapper', service.isSideNavigationOpen && 'open')}>
        <Icon
          className="chevron_double_right"
          name="chevron_double_right"
          size={10}
          color="var(--Colors-Gray-700)"
        />
      </div>
    </button>
  )
}

export default observer(SideNavigationOpenButton)

const _Style = css`
  position: absolute;
  display: none;
  width: 112px;
  justify-content: space-between;
  align-items: center;
  padding: 5px 12px;
  border-radius: 18px;
  background-color: var(--Colors-Gray-100);
  ${typo.caption01};
  color: var(--Colors-Gray-800);

  ${mediaQuery.large} {
    display: flex;
  }

  .left {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .dot {
    width: 7px;
    height: 7px;
    border-radius: var(--Radius-Circle);
    background-color: var(--Colors-Gray-400);
  }

  .open {
    transform: rotate(180deg);
  }
`
